import './Button.css';const button = "_button_1yx8h_3";
const icon = "_icon_1yx8h_49";
const loading = "_loading_1yx8h_57";
const styles = {
	button: button,
	"type-icon": "_type-icon_1yx8h_3",
	icon: icon,
	loading: loading,
	"loading-spinner": "_loading-spinner_1yx8h_60",
	"size-small": "_size-small_1yx8h_63",
	"size-medium": "_size-medium_1yx8h_72",
	"size-large": "_size-large_1yx8h_80",
	"appearance-primary": "_appearance-primary_1yx8h_88",
	"appearance-secondary": "_appearance-secondary_1yx8h_103",
	"appearance-ghost": "_appearance-ghost_1yx8h_118",
	"danger-primary": "_danger-primary_1yx8h_133",
	"danger-secondary": "_danger-secondary_1yx8h_148",
	"button-compound": "_button-compound_1yx8h_213",
	"shape-rounded": "_shape-rounded_1yx8h_234",
	"shape-pill": "_shape-pill_1yx8h_237",
	"shape-circular": "_shape-circular_1yx8h_240",
	"button-toggle": "_button-toggle_1yx8h_245"};

export { styles as s };
//# sourceMappingURL=Button.module-CDPD2nx9-CDPD2nx9.js.map
